import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import { toast } from "react-toastify";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./CSS/DailyDeals.css";
import { useUserContext } from "../../Context/Context";

const settings = {
  dots: false,
  customPaging: () => <span className="custom-dot" />,
  dotsClass: "slick-dots custom-dots",
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const formatTime = (time) => {
  let days = Math.floor(time / (1000 * 60 * 60 * 24));
  const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((time % (1000 * 60)) / 1000);
  if (days > 7) days = 7;
  return `${days.toString().padStart(2, "0")} DAYS : ${hours
    .toString()
    .padStart(2, "0")} HOURS : ${minutes
    .toString()
    .padStart(2, "0")} MINS : ${seconds.toString().padStart(2, "0")} SECS`;
};

const DailyDeals = () => {
  const [products, setProducts] = useState([]);
  const [timers, setTimers] = useState([]);
  const { addToCart, cart } = useUserContext();

  useEffect(() => {
    axios
      .get("https://dehleze.shop/product-create/")
      .then((res) => {
        console.log("Fetched products data:", res.data); // Log data to console

        const now = new Date().getTime();
        const filtered = res.data
          .filter((product) => product.feature_product === "Normal")
          .map((product) => {
            const image =
              product.images?.[0]?.image || product.product_image || "";
            const discount = parseFloat(product.discount_percentage || 0);
            const price = parseFloat(product.price || 0);
            const salePrice = price - (price * discount) / 100;
            const sold = Math.floor(Math.random() * 10) + 1;
            // const available = Math.floor(Math.random() * 20) + 10;

            return {
              id: product.id,
              title: product.name,
              image,
              discount,
              originalPrice: price,
              salePrice,
              description: product.short_description,
              sold,
              // available,
              countdownEnd: now + 5 * 24 * 60 * 60 * 1000,
              seller_id: product.seller, // Include seller_id if needed
            };
          });

        console.log("Filtered products:", filtered); // Log filtered data to console

        setProducts(filtered);
        setTimers(filtered.map((p) => p.countdownEnd - new Date().getTime()));
      })
      .catch((err) => console.error("API fetch error:", err));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimers((prev) =>
        prev.map((_, index) =>
          Math.max(products[index]?.countdownEnd - new Date().getTime(), 0)
        )
      );
    }, 1000);
    return () => clearInterval(interval);
  }, [products]);

  const handleAddToCart = (product) => {
    if (product.available === 0) {
      toast.error("Sorry, this product is out of stock!");
      return;
    }

    const exists = cart.some((item) => item.id === product.id);
    if (exists) {
      toast.warning("Product already exists in the cart!");
    } else {
      // ✅ Format product for cart and checkout compatibility
      const formattedProduct = {
        id: product.id,
        name: product.title,
        price: product.salePrice,
        images: [{ image: product.image }],
        seller_id: product.seller_id || null,
      };

      addToCart(formattedProduct);
      toast.success("Product added to cart successfully!");
    }
  };

  return (
    <div className="daily-deals">
      <div className="d-products-container">
        <Slider {...settings}>
          {products.map((product, index) => (
            <div key={product.id} className="product-item">
              <div className="product-item-image">
                <div className="discount-badge">-{product.discount}%</div>
                <img src={product.image} alt={product.title} />
              </div>

              <div className="d-hover-icons">
                <div className="d-icon">
                  <i className="fa-solid fa-heart"></i>
                </div>
                <div className="d-icon">
                  <i className="fa fa-eye" aria-hidden="true"></i>
                </div>
                <div
                  className="d-icon"
                  onClick={() => handleAddToCart(product)}
                >
                  <i className="fa-solid fa-cart-shopping"></i>
                </div>
              </div>

              <div className="product-item-content">
                <h4 className="d-h4">{product.title}</h4>
                <div className="product-pricing">
                  <span className="original-price">
                    Rs{product.originalPrice}
                  </span>
                  <span className="sale-price">
                    Rs{product.salePrice.toFixed(0)}
                  </span>
                </div>
                <p className="d-product-description">{product.description}</p>

                <div className="stock-info">
                  {/* <div>
                    Available: <span>{product.available}</span>
                  </div> */}
                  {/* <div>
                    Sold: <span>{product.sold}</span>
                  </div> */}
                </div>

                <div className="countdown">
                  Hurry Up! Offers End In:
                  <div className="countdown-timer">
                    {formatTime(timers[index] || 0)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default DailyDeals;
